import { Link } from 'react-router-dom';

const portfolioImages = [
  {
    src: 'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/kitchen/kitchen13.webp',
    alt: 'Stunning modern kitchen remodel with custom cabinets and island',
    title: 'Kitchen Remodels',
    description: 'Transform your kitchen into a stunning, functional space'
  },
  {
    src: 'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/bath/bath3.webp',
    alt: 'Luxurious bathroom remodel with modern fixtures',
    title: 'Bathroom Remodels',
    description: 'Create your perfect bathroom sanctuary'
  },
  {
    src: 'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/cabinets/cabinets14.webp',
    alt: 'Custom cabinet design and installation',
    title: 'Custom Cabinets',
    description: 'Expert craftsmanship for every room'
  }
];

export const PortfolioPreview = () => {
  return (
    <section className="relative -top-8 py-16 sm:py-20 md:py-24 bg-gray-200">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="mb-8 sm:mb-10 md:mb-12 text-center">
          <h2 className="mb-6 sm:mb-8 md:mb-10 text-3xl sm:text-4xl font-bold text-gray-900">
            Our Featured Work
          </h2>
          <p className="text-lg sm:text-xl text-gray-600">
            Discover how we transform spaces into stunning, functional
            environments
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-3">
          {portfolioImages.map((image, index) => (
            <Link
              to="/gallery"
              key={index}
              className="overflow-hidden relative rounded-lg shadow-lg transition-all duration-300 group hover:shadow-xl">
              <div className="relative pb-[75%]">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="object-cover absolute inset-0 w-full h-full transition-transform duration-300 transform group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex absolute inset-0 flex-col justify-end p-4 sm:p-6 bg-black bg-opacity-40 transition-all duration-300 group-hover:bg-opacity-50">
                <h3 className="mb-2 text-xl sm:text-2xl font-bold text-white">
                  {image.title}
                </h3>
                <p className="text-base sm:text-lg text-white opacity-90">
                  {image.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 sm:mt-10 md:mt-12 text-center">
          <Link
            to="/gallery"
            className="inline-flex items-center px-6 sm:px-8 py-3 text-sm sm:text-base font-medium text-white rounded-md border border-transparent transition-colors duration-300 bg-primary hover:bg-primary-hover">
            View Our Full Portfolio
          </Link>
        </div>
      </div>
    </section>
  );
};
